var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homeContainer"},[_vm._v(" HOME ")])
}
var staticRenderFns = []

export { render, staticRenderFns }